module.exports = __webpack_public_path__ + "img/nara.6bc7e320.png";